import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@storeblocks/button';
import LoadingIndicator from '@storeblocks/loading-indicator';
import { getText } from '@storebrand-digital/fms-translations';
import ErrorComponent from '../ErrorComponent/index';
import { ButtonWrap, Input, SpinnerWrap, Wrap } from './styled';
import { useModalContext } from '../Context';
import { saveEmailRequested } from '../../containers/Inbox/redux/threadSlice';
function Email(_a) {
    var setShowEmail = _a.setShowEmail, label = _a.label;
    var dispatch = useDispatch();
    var _b = useModalContext(), setHeading = _b.setHeading, setFooter = _b.setFooter;
    var _c = useState(''), emailValue = _c[0], setEmailValue = _c[1];
    var _d = useState(undefined), validation = _d[0], setValidation = _d[1];
    var _e = useState(false), showValidation = _e[0], setShowValidation = _e[1];
    var _f = useSelector(function (state) { return state.messageThreads.saveEmailState; }), loading = _f.loading, error = _f.error, success = _f.success;
    useEffect(function () {
        if (success) {
            setShowEmail(false);
        }
    }, [success]);
    useEffect(function () {
        setHeading(label);
        setFooter(null);
    }, [setHeading, setFooter, label]);
    var onEmailChange = function (event) {
        var _a = event.target, value = _a.value, validity = _a.validity;
        if (value === '') {
            setValidation(getText('email.validation.empty'));
        }
        else if (!validity.valid) {
            setValidation(getText('email.validation.invalid'));
        }
        else {
            setValidation(undefined);
        }
        setEmailValue(value);
    };
    var onEmailSave = function () {
        if (!validation) {
            dispatch(saveEmailRequested(emailValue));
        }
        else {
            setShowValidation(true);
        }
    };
    var skipEmail = function () {
        setShowEmail(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("p", null, getText('email.description')),
        React.createElement(Wrap, null,
            React.createElement(Input, { id: "email", name: "email", label: "E-post:", type: "email", size: "large", value: emailValue, onChange: onEmailChange, error: showValidation && validation, "data-hj-suppress": true }),
            loading && (React.createElement(SpinnerWrap, null,
                React.createElement(LoadingIndicator, null))),
            error && React.createElement(ErrorComponent, { error: error }),
            React.createElement(ButtonWrap, null,
                React.createElement(Button, { "data-trackid": "button-email_save|".concat(getText('email.save.label')), onClick: onEmailSave }, getText('email.save.label')),
                React.createElement("button", { type: "button", onClick: skipEmail, className: "link", "data-trackid": "button-email_continue_without_saving|".concat(getText('email.continue.label')) }, getText('email.continue.label'))))));
}
export default Email;
